"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rowsPerPageOptions = exports.roleOptions = exports.pwdResetOptions = exports.columns = void 0;
exports.getRoleColor = getRoleColor;
var columns = [
    { name: "NAME", uid: "name" },
    { name: "EMAIL", uid: "email" },
    { name: "GENDER", uid: "gender" },
    { name: "CONTACT NUMBER", uid: "contactNumber" },
    { name: "ROLE", uid: "role" },
    { name: "PERMISSIONS COUNT", uid: "permissionsCount" },
    { name: "PASSWORD RESET REQUIRED", uid: "pwdResetRequired" },
    { name: "DATE CREATED", uid: "createdAt" },
    { name: "ACTIONS", uid: "actions" },
];
exports.columns = columns;
var roleOptions = [
    { key: "all", label: "All Roles" },
    { key: "Admin", label: "Admin" },
    { key: "User", label: "User" },
];
exports.roleOptions = roleOptions;
var pwdResetOptions = [
    { key: "all", label: "All" },
    { key: "yes", label: "Yes" },
    { key: "no", label: "No" },
];
exports.pwdResetOptions = pwdResetOptions;
var rowsPerPageOptions = [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
var roleColorMap = {
    owner: "danger",
    admin: "primary",
    manager: "warning",
    user: "secondary",
};
function getRoleColor(role) {
    return roleColorMap[role.toLowerCase()] || "default";
}
